/* SENDA MARCADA - el porcentaje en la etiqueta de rebaja de la tarjeta

   En vaperenlinea.com la etiqueta de la tarjeta no dice "Oferta", dice cuanto se
   ahorra: "-46 %". Medido alli el 15/10/2026.

   Por que va en JavaScript y no en la plantilla: el texto lo escribe
   snippets/card-product.liquid, que pesa 36.297 caracteres, y la API de temas corta
   cada subida en 16.384. No se puede reescribir ese archivo desde aqui, asi que el
   porcentaje se calcula leyendo los dos precios que la propia tarjeta ya pinta.

   DOS ETIQUETAS POR TARJETA. Medido el 15/10: Dawn pinta la etiqueta dos veces en
   cada tarjeta (una por cada estado de la imagen), asi que la primera version de
   este guion, que solo tocaba la primera, dejaba 24 diciendo "Oferta" de 52. Ahora
   recorre todas.

   LAS AGOTADAS NO SE TOCAN. Se distinguen por el esquema de color: en
   config/settings_data.json la rebaja usa scheme-5 y el agotado scheme-3. Si algun
   dia se cambia ese ajuste, hay que cambiar tambien esta linea.

   Es un adorno: si no encuentra los precios o no puede calcular, deja la etiqueta
   como estaba y no rompe nada. Tampoco toca el precio ni el enlace.

   Se vuelve a pasar cuando cambia el contenido (filtros de coleccion, paginacion,
   recomendaciones), porque esas partes se repintan por JavaScript y las tarjetas
   nuevas llegan despues de la primera pasada. */
(function () {
  if (window.sendaTarjetas) return;
  window.sendaTarjetas = true;

  var ESQUEMA_AGOTADO = 'color-scheme-3';

  function aNumero(txt) {
    if (!txt) return NaN;
    var limpio = txt.replace(/[^\d.,]/g, '');
    if (!limpio) return NaN;
    // formato espanol: el punto separa miles y la coma los decimales
    limpio = limpio.replace(/\./g, '').replace(',', '.');
    return parseFloat(limpio);
  }

  function pinta(tarjeta) {
    var etiquetas = tarjeta.querySelectorAll('.badge');
    if (!etiquetas.length) return;

    var tachado = tarjeta.querySelector('s .price-item, s.price-item');
    var rebajado = tarjeta.querySelector('.price-item--sale');
    if (!tachado || !rebajado) return;

    var antes = aNumero(tachado.textContent);
    var ahora = aNumero(rebajado.textContent);
    if (!isFinite(antes) || !isFinite(ahora) || antes <= 0 || ahora >= antes) return;

    var pct = Math.round((1 - ahora / antes) * 100);
    if (pct < 1) return;

    for (var i = 0; i < etiquetas.length; i++) {
      var e = etiquetas[i];
      if (e.dataset.sendaHecho) continue;
      if (e.classList.contains(ESQUEMA_AGOTADO)) continue;
      e.textContent = '-' + pct + ' %';
      e.dataset.sendaHecho = '1';
    }
  }

  function pasada() {
    document.querySelectorAll('.card-wrapper').forEach(pinta);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pasada);
  } else {
    pasada();
  }

  // las colecciones y las recomendaciones repintan tarjetas por JavaScript
  var pendiente = null;
  new MutationObserver(function () {
    clearTimeout(pendiente);
    pendiente = setTimeout(pasada, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
